import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';
import { Draggable } from "gsap/Draggable";

gsap.registerPlugin(Draggable);

if($(".wp-block-thefuturblocks-testimonials").length > 0) {
  $(".wp-block-thefuturblocks-testimonials").each(function() {
    var self = $(this),
      slides = self.find(".wp-block-thefuturblocks-testimonial"),
      imgs = self.find(".wp-block-thefuturblocks-testimonial__image"),
      conts = self.find(".wp-block-thefuturblocks-testimonial__content"),
      dots = self.find(".wp-block-thefuturblocks-testimonials__dots"),
      wrapper = self.find(".wp-block-thefuturblocks-testimonials__wrapper"),
      navPrev = self.find(".wp-block-thefuturblocks-testimonials__nav-prev"),
      navNext = self.find(".wp-block-thefuturblocks-testimonials__nav-next"),
      activeDotColor = dots.attr("data-active"),
      dotColor = dots.attr("data-dot"),
      highestSlide = 0,
      moveSlideTL = gsap.timeline();
    let nextLoop;

    function dotClick() {
      if(!moveSlideTL.isActive()) {
        var slideFrom = self.find(".wp-block-thefuturblocks-testimonial.active"),
            imgFrom = slideFrom.find(".wp-block-thefuturblocks-testimonial__image"),
            contFrom = slideFrom.find(".wp-block-thefuturblocks-testimonial__content"),
            sectionToIndex = $(this).index(),
            slideTo = slides.eq(sectionToIndex),
            imgTo = imgs.eq(sectionToIndex),
            contTo = conts.eq(sectionToIndex);
        
        if(slideFrom.index() !== slideTo.index()) {
          if(slides.index(slideFrom) < slides.index(slideTo)) {
            moveToSlide(slideFrom, slideTo, imgFrom, imgTo, contFrom, contTo);
          } else {
            moveFromSlide(slideFrom, slideTo, imgFrom, imgTo, contFrom, contTo);
          }
        }

        if (self.hasClass("has-autoplay")) {
          // Stop the last one
            nextLoop.kill();
            // Start it again
            looper();
        }
      }
    }

    function nextClick() {
      if(!moveSlideTL.isActive()) {
        var slideFrom = self.find(".wp-block-thefuturblocks-testimonial.active"),
            imgFrom = slideFrom.find(".wp-block-thefuturblocks-testimonial__image"),
            contFrom = slideFrom.find(".wp-block-thefuturblocks-testimonial__content"),
            sectionToIndex = slides.index(slideFrom);

        if(sectionToIndex !== slides.length - 1) {
          var slideTo = slides.eq(sectionToIndex + 1),
              imgTo = imgs.eq(sectionToIndex + 1),
              contTo = conts.eq(sectionToIndex + 1);
          moveToSlide(slideFrom, slideTo, imgFrom, imgTo, contFrom, contTo);
        } else {
          slideTo = slides.eq(0);
          imgTo = imgs.eq(0);
          contTo = conts.eq(0);
          moveToSlide(slideFrom, slideTo, imgFrom, imgTo, contFrom, contTo);
        }

        if (self.hasClass("has-autoplay")) {
          // Stop the last one
            nextLoop.kill();
            // Start it again
            looper();
        }
      }
    }

    function prevClick() {
      if(!moveSlideTL.isActive()) {
        var slideFrom = self.find(".wp-block-thefuturblocks-testimonial.active"),
            imgFrom = slideFrom.find(".wp-block-thefuturblocks-testimonial__image"),
            contFrom = slideFrom.find(".wp-block-thefuturblocks-testimonial__content"),
          sectionToIndex = slides.index(slideFrom);
        
        if(sectionToIndex !== 0) {
          var slideTo = slides.eq(sectionToIndex - 1),
              imgTo = imgs.eq(sectionToIndex - 1),
              contTo = conts.eq(sectionToIndex - 1);
          moveFromSlide(slideFrom, slideTo, imgFrom, imgTo, contFrom, contTo);
        } else {
          slideTo = slides.eq(slides.length - 1);
          imgTo = imgs.eq(slides.length - 1);
          contTo = conts.eq(slides.length - 1);
          moveFromSlide(slideFrom, slideTo, imgFrom, imgTo, contFrom, contTo);
        }

        if (self.hasClass("has-autoplay")) {
          // Stop the last one
            nextLoop.kill();
            // Start it again
            looper();
        }
      }
    }

    function moveToSlide(slideFrom, slideTo, imgFrom, imgTo, contFrom, contTo) {
      moveSlideTL = gsap.timeline({onStart: setActiveSlide, onStartParams: [slideTo]})
      .to(imgFrom, {duration:0.6,yPercent:-100})
      .to(contFrom, {duration:0.6,xPercent:-100,skewX:30, autoAlpha:0},"<")
      .set(slideTo, {autoAlpha:1, className: "wp-block-thefuturblocks-testimonial active"}, "<")
      .set(slideFrom, {className: "wp-block-thefuturblocks-testimonial"}, "<")

      .fromTo(imgTo, {yPercent:100}, {duration:0.6,yPercent:0}, "<")
      .fromTo(contTo, {xPercent:100,skewX:30, autoAlpha:0},
       {duration: 0.6, xPercent:0,skewX:0, autoAlpha:1,force3D:false}, "<")
      .set(slideFrom, {autoAlpha:0})
    }

    function moveFromSlide(slideFrom, slideTo, imgFrom, imgTo, contFrom, contTo) {
      moveSlideTL = gsap.timeline({onStart: setActiveSlide, onStartParams: [slideTo]})
      .to(imgFrom, {duration:0.6,yPercent:100})
      .to(contFrom, {duration:0.6,xPercent:100,skewX:-30, autoAlpha:0},"<")
      .set(slideTo, {autoAlpha:1, className: "wp-block-thefuturblocks-testimonial active"}, "<")
      .set(slideFrom, {className: "wp-block-thefuturblocks-testimonial"}, "<")

      .fromTo(imgTo, {yPercent:-100}, {duration:0.6,yPercent:0}, "<")
      .fromTo(contTo, {xPercent:-100,skewX:-30, autoAlpha:0},
       {duration: 0.6, xPercent:0,skewX:0, autoAlpha:1,force3D:false}, "<")
      .set(slideFrom, {autoAlpha:0})
    }

    function setActiveSlide(slideTo) {
      var currentSlideIndex = slides.index(slideTo),
        activeDot = self.find(".wp-block-thefuturblocks-testimonials__dot.active"),
        activeDotInner = activeDot.find(".wp-block-thefuturblocks-testimonials__dot-inner"),
        activeDotIndex = activeDot.find(".wp-block-thefuturblocks-testimonials__dot-index"),
        defDot = self.find(".wp-block-thefuturblocks-testimonials__dot").eq(currentSlideIndex),
        defDotInner = defDot.find(".wp-block-thefuturblocks-testimonials__dot-inner"),
        defDotIndex = defDot.find(".wp-block-thefuturblocks-testimonials__dot-index");

      gsap.to(activeDot, {duration:0.6,className: "wp-block-thefuturblocks-testimonials__dot"});
      gsap.to(activeDotInner, {duration:0.6,y:0,backgroundColor:dotColor});
      gsap.to(defDot, {duration:0.6,className: "wp-block-thefuturblocks-testimonials__dot active"});
      gsap.to(defDotInner, {duration:0.6,y:-21,backgroundColor:activeDotColor});
      gsap.to(defDotIndex, {duration:0.6,y:0,color:activeDotColor});
      gsap.to(activeDotIndex, {duration:0.6,y:21,color:dotColor});

    }

    if(self.hasClass("is-draggable")) {
      var proxy = $('<div></div>');
      Draggable.create(proxy, {
        trigger: wrapper,
        type: "x",
        cursor: "grab",
        activeCursor: "grabbing",
        onDrag: function() {
          if(this.deltaX > 10) {
            prevClick();
          }
          if(this.deltaX < -10) {
            nextClick();
          }
        }
      });
    }

    function looper() {
      var autoplayTimer = self.data("autoplay");
      nextLoop = gsap.delayedCall(autoplayTimer, function() {
        nextClick();
      });
    }

    if (self.hasClass("has-autoplay")) {
      looper();
    }

    function navHover() {
      const nextArrow = navNext.find('.thefutur-icons'),
        prevArrow = navPrev.find('.thefutur-icons'),
          tlPrev = gsap.timeline({paused:true}),
          tlNext = gsap.timeline({paused:true});

      tlNext.to(nextArrow, {duration:0.15,xPercent:100,ease: "sine.in"})
      .fromTo(nextArrow, {xPercent:-100}, {duration:0.15,xPercent:0,immediateRender:false,ease:"sine.out"});

      tlPrev.to(prevArrow, {duration:0.15,xPercent:-100,ease: "sine.in"})
      .fromTo(prevArrow, {xPercent:100}, {duration:0.15,xPercent:0,immediateRender:false,ease:"sine.out"});

      navNext.on("mouseenter", () => {
        tlNext.play();
      }).on("mouseleave", () => {
        tlNext.reverse();
      })

      navPrev.on("mouseenter", () => {
        tlPrev.play();
      }).on("mouseleave", () => {
        tlPrev.reverse();
      })
    }

    function init() {
      for( var i = 0; i < slides.length; i++ ) {
        var dot = $('<div></div>').addClass("wp-block-thefuturblocks-testimonials__dot").appendTo(dots);
        var dotInner = $('<div></div>').addClass("wp-block-thefuturblocks-testimonials__dot-inner").appendTo(dot);
        var dotIndex = $('<div></div>').addClass("wp-block-thefuturblocks-testimonials__dot-index").appendTo(dot);

        var dotNumber = i + 1;
        if(dotNumber.toString().length < 2) dotNumber = '0' + dotNumber;
        dotIndex.text(dotNumber);
      }
        self.find(".wp-block-thefuturblocks-testimonials__dot:first-child").addClass("active");
        var dotClicked = self.find(".wp-block-thefuturblocks-testimonials__dot");
        var dotClickedInner = dotClicked.find(".wp-block-thefuturblocks-testimonials__dot-inner");
        var dotClickedIndex = dotClicked.find(".wp-block-thefuturblocks-testimonials__dot-index");
        gsap.set(dotClickedInner, {backgroundColor: dotColor});
        dotClicked.on('click', dotClick);

        gsap.set(dotClickedIndex,{y:21, color: dotColor});

      navNext.on('click', nextClick);
      navPrev.on('click', prevClick);
      
      slides.each(function(){
        if($(this).outerHeight() > highestSlide) {
          highestSlide = $(this).outerHeight();
        }
      })

      navHover()

      var activeSlide = self.find(".wp-block-thefuturblocks-testimonial:first"),
        slidesWrapper = self.find(".wp-block-thefuturblocks-testimonials__wrapper"),
        activeDot = self.find(".wp-block-thefuturblocks-testimonials__dot.active"),
        activeDotInner = activeDot.find(".wp-block-thefuturblocks-testimonials__dot-inner");

      var activeDotIndex = $(".wp-block-thefuturblocks-testimonials__dot.active").find(".wp-block-thefuturblocks-testimonials__dot-index");

      gsap.set(activeSlide, {autoAlpha:1, className: "wp-block-thefuturblocks-testimonial active"});
      gsap.set(activeDotInner, {y:-21,backgroundColor: activeDotColor});
      gsap.set(slidesWrapper, {height: highestSlide});

      gsap.set(activeDotIndex, {y:0, color: activeDotColor});
      gsap.set(".wp-block-thefuturblocks-testimonials__nav-prev", {color:dotColor})
      gsap.set(".wp-block-thefuturblocks-testimonials__nav-next", {color:dotColor})
    }

    init();
  })
}